import axiosInstance from "../utils/axios";

export const GetArticulationOptions = async (pmcId) => {
  return await axiosInstance().get(`/getArticulationOptions/${pmcId}`);
};

export const GetReRegistrationList = async () => {
  return await axiosInstance().get("/reRegistrationList");
};

export const getReRegistrationService = async (regid) => {
  return await axiosInstance().get("/getReRegistration", {
    params: { regid: regid },
  });
};

export const UploadFileToNetsuite = async (values) => {
  return await axiosInstance().post(`/uploadFileToNetsuite`, values);
};

export const SubmitFilesUploadedReReg = async (values) => {
  return await axiosInstance().post(`/submitFilesUploadedReReg`, values);
};

export const GetFileTypeMapping = async () => {
  return await axiosInstance().get("/getFileTypeMapping");
}
export const GetRegistrationFiles = async (regid) => {
  return await axiosInstance().post("/getRegistrationFiles", {
    regid: regid,
  });
}
export const getReRegistrationSubjectService = async (value) => {
  return await axiosInstance().get("getReRegistrationSubject", {
    params: { regid: value },
  });
};

export const getReRegistrationReadOnlySubjectService = async (values) => {
  return await axiosInstance().get("getReRegistrationReadOnlySubject", {
    params: { studentNewRegId: values },
  });
};

export const submitReRegistrationService = async (values) => {
  return await axiosInstance().post("submitReRegistration", values);
};


export const GetReRegNotSubmitReasonsList = async () => {
  return await axiosInstance().get("/getReRegNotSubmitReasonsList");
};

export const ReRegistrationRemindMeLater = async (values) => {
  return await axiosInstance().post("/reRegistrationRemindMeLater",values);
};

/**
 * Get account payer details for a student
 * @param {string|number} studentId - The student ID (required)
 * @returns {Promise} Axios response containing account payer/sponsor details
 */
export const GetAccountPayerDetails = async (studentId) => {
  return await axiosInstance().get("/getSponsorDetails", {
    params: { studentId: studentId },
  });
};

/**
 * Update account payer/sponsor details for a student
 * @param {Object} values - The account payer/sponsor details to update
 * @returns {Promise} Axios response from the update operation
 */
export const UpdateAccountPayer = async (values) => {
  return await axiosInstance().post("/updateSponsorDetails", values);
};

export const ArticulationRegistrationList = async () => {
  return await axiosInstance().get("/ArticulationRegistrationList");
};

// export const GetArticulationProgramms = async (value) => {
//   return await axiosInstance().get(`/getArticulationProgramms?articulation_id=${value}`);
// };

export const articulationRegistrationRemindMeLater = async (value) => {
  return await axiosInstance().post(`/articulationRegistrationRemindMeLater`,value);
};

export const WitheldStatusRemindMeLater = async () => {
  return await axiosInstance().post(`/WitheldStatusRemindMeLater`);
};

export const submitArticulationRegistration = async (value) => {
  return await axiosInstance().post(`/submitArticulationRegistration`,value);
};

export const GetQualificationsList = async (value) => {
  return await axiosInstance().get(`/getQualification/?viaSchool=${value?.school}&viaLearning=${value?.learningMethod}&uniqueDataKey=${value?.uniqueDataKey}`);
};

export const GetProgressionSubjects = async (value, options = {}) => {
  return await axiosInstance().post(`/getProgressionSubjects`, value, options);
};

export const CheckProgressionSubject = async (value) => {
  return await axiosInstance().get(`/checkProgressionSubjects`,{params : value});
};

export const getArticulationOptionList = async (values) => {
  return await axiosInstance().get(`/getArticulationOptionList?rereg_id=${values.re_reg_id}&type=${values.type || ""}&campus=${values.campus || ""}`);
};

export const getQualificationDetails = async (values, cancelToken) => {
  return await axiosInstance().get(`/getQualificationDetails?qualificationId=${values}`, { cancelToken });
}

export const GetReRegistrationFileDownloads = async () => {
  return await axiosInstance().get("/reRegistrationFileDownloads");
};